import { upperFirst, camelCase } from "lodash";
import Constants from "@/utils/Const";

// делаем функции $canAdd, $canView... по списку констант add, view...
const permissionMethods = {};
Constants.CrudSuffix.forEach(suffix => {
  const methodName = `$can${upperFirst(camelCase(suffix))}`;
  permissionMethods[methodName] = function() {
    const moduleName = this.$route.name;
    if (["Node", "NodeChildren", "NodeWithParentSpec"].includes(moduleName)) {
      return this.$store.getters.hasNodePermission(
        this.$route.params.id,
        suffix
      );
    } else {
      const permissionCode = `${moduleName}/${suffix}`;
      return this.$store.getters.hasNavPermission(permissionCode);
    }
  };
});

export default {
  computed: {
    hasPermission() {
      return action => {
        // Имя роута, совпадает с workplace в таблице navs
        const moduleName = this.$route.name;
        const permissionCode = `${moduleName}/${action}`;
        return this.$store.getters.hasNavPermission(permissionCode);
      };
    },
    hasNavPermissionByName() {
      return permissionName => {
        return this.$store.getters.hasNavPermission(permissionName);
      };
    }
  },
  methods: {
    // метод, проверяющий доступ по коду (Dashboard/view, Users/add...)
    $can(param) {
      return this.$store.getters.hasNavPermission(param);
    },
    $canViewHistory() {
      return this.$store.getters.hasNavPermission("HistoryActions/view");
    },

    // дополняем примесь функциями $canAdd, $canView...
    ...permissionMethods
  }
};
